<template>

<core-modal v-on:close="onClose" :is-empty="!fields.length" :softloading="is.saving" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		{{ item.name }}

	</template>

	<template v-slot:default>

        <div class="manage-empty" v-if="!fields.length">

            No fields added to view.

        </div>

		<com-field 
			v-for="(field, index) in fields" 
			:key="field.id" 
			:field="field" 
			:view="item" 
			:is-first="index === lockedCount" 
			:is-last="index === fields.length - 1" 
			v-on:up="onMoveUp(index)"
			v-on:down="onMoveDown(index)"
		/>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onAddClick" v-if="canAdd">Add Field</core-button>

		<core-button theme="blue" v-on:click.native="onEditClick">Settings</core-button>

	</template>

</core-modal>

</template>

<script>

import $field from '@/field'
import comField from './view/Field'

export default {

	props: ['data'],

	components: {
		comField
	},
	
	data: function() {

		return {

			is: {
				saving: false,
				loading: false
			}

		}

	},

	computed: {

		canAdd: function() {

			var viewType = ''

			if (this.item.type === 1) viewType = 'list'
			if (this.item.type === 2) viewType = 'sheet'
			if (this.item.type === 3) viewType = 'grid'
			if (this.item.type === 4) viewType = 'gallery'
			
			return this.$_.filter($field.types, function(field) {

				return (this.$_.isArray(field.lang.views)) ? this.$_.contains(field.lang.views, viewType) : field.lang.views === viewType

			}.bind(this)).length

		},

		lockedCount: function() {

			return this.$_.filter(this.fields, function(field) {

				return field.locked

			}).length

		},

        item: function() {

            return this.$_.find(this.$store.getters['data/views/list'], function(view) {

                return view.id === this.data.view

            }.bind(this))

        },

		fields: function() {

			return this.item.fields || []

		}

	},

	methods: {

		onMoveUp: function(index) {

			const a = this.item.fields[index - 1]
			const b = this.item.fields[index]

			this.$set(this.item.fields, index - 1, b)
			this.$set(this.item.fields, index, a)

			this.is.saving = true

			this.$api.post('views/view/save', {
				model: this.item
			}).then(function(response) {

				this.$store.commit('data/views/update', [response])

				this.is.saving = false

			}.bind(this))

		},

		onMoveDown: function(index) {

			const a = this.item.fields[index]
   	 		const b = this.item.fields[index + 1]

    		this.$set(this.item.fields, index, b)
    		this.$set(this.item.fields, index + 1, a)
			
			this.is.saving = true

			this.$api.post('views/view/save', {
				model: this.item
			}).then(function(response) {

				this.$store.commit('data/views/update', [response])

				this.is.saving = false

			}.bind(this))

		},

        onAddClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsViewAdd',
				view: this.data.view
			})	

        },

        onEditClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsViewSettings',
				view: this.data.view
			})	

        },

		onClose: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'viewsManage'
			})	

		}

	}

}

</script>

<style scoped>

.manage-empty {
    position: absolute;
    left: 0%;
    top: 50%;
    width: 100%;
    font-size: 20px;
    color: #fff;
    opacity: 0.75;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    padding: 16px;
}

</style>